export const SET_PRODUCTS = 'funnel/SET_PRODUCTS';
export const SET_QUESTIONS = 'funnel/SET_QUESTIONS';
export const SET_EXPERIMENTS = 'funnel/SET_EXPERIMENTS';
